import { ApiBase } from './ApiBase';
class InternalApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getActiveCampaign = (queryParams) => {
            return this.get('/internal/campaign/active', queryParams);
        };
        this.enrollCampaign = (body) => {
            return this.post('/internal/campaign/enroll', body);
        };
        this.getEnrolledCampaign = () => {
            return this.get('/internal/campaign/current-enrolled');
        };
        this.getCampaign = () => {
            return this.get('/internal/campaign');
        };
    }
}
export const InternalApiClient = new InternalApiClientModel();
